module.exports = __webpack_public_path__ + "img/DSCN2044.87309afc.jpg";